import React, { useState } from "react";
import { useAuth } from "./AuthContext";
import { useNavigate } from "react-router-dom";
import { Form, Input, Button, Card, message, Typography, Space } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const Login = () => {
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (values) => {
        setLoading(true);
        const response = await login(values.email, values.password);
        setLoading(false);

        if (response.success) {
            message.success("ਸਫਲਤਾਪੂਰਵਕ ਲੌਗਇਨ ਹੋਇਆ | Login successful");
            navigate("/");
        } else {
            message.error(response.message || "Invalid credentials");
        }
    };

    return (
        <div
            style={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "linear-gradient(135deg, #222e61 0%, #1a2347 50%, #0f1629 100%)",
                padding: "20px",
            }}
        >
            <Card
                style={{
                    width: "100%",
                    maxWidth: 420,
                    borderRadius: 16,
                    boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
                    border: "none",
                }}
                bodyStyle={{ padding: "40px" }}
            >
                <div style={{ textAlign: "center", marginBottom: 32 }}>
                    <img
                        src="https://brantsikhs.com/logo.png"
                        alt="Sikh Association of Brantford"
                        style={{
                            maxHeight: 100,
                            marginBottom: 16,
                        }}
                    />
                    <Title level={3} style={{ margin: 0, color: "#222e61" }}>
                        ਸਿੱਖ ਐਸੋਸੀਏਸ਼ਨ ਆਫ਼ ਬ੍ਰੈਂਟਫੋਰਡ
                    </Title>
                    <Text type="secondary" style={{ fontSize: 14 }}>
                        Sikh Association of Brantford
                    </Text>
                </div>

                <Form
                    onFinish={handleSubmit}
                    layout="vertical"
                    size="large"
                >
                    <Form.Item
                        name="email"
                        rules={[{ required: true, message: "ਕਿਰਪਾ ਕਰਕੇ ਈਮੇਲ ਦਰਜ ਕਰੋ" }]}
                    >
                        <Input
                            prefix={<UserOutlined style={{ color: "#222e61" }} />}
                            placeholder="ਈਮੇਲ / Email"
                            style={{
                                borderRadius: 8,
                                height: 50,
                            }}
                        />
                    </Form.Item>
                    
                    <Form.Item
                        name="password"
                        rules={[{ required: true, message: "ਕਿਰਪਾ ਕਰਕੇ ਪਾਸਵਰਡ ਦਰਜ ਕਰੋ" }]}
                    >
                        <Input.Password
                            prefix={<LockOutlined style={{ color: "#222e61" }} />}
                            placeholder="ਪਾਸਵਰਡ / Password"
                            style={{
                                borderRadius: 8,
                                height: 50,
                            }}
                        />
                    </Form.Item>

                    <Form.Item style={{ marginBottom: 0, marginTop: 24 }}>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            block
                            style={{
                                height: 50,
                                borderRadius: 8,
                                fontSize: 16,
                                fontWeight: 600,
                                background: "linear-gradient(135deg, #222e61 0%, #3a4a8f 100%)",
                                border: "none",
                                boxShadow: "0 4px 15px rgba(34, 46, 97, 0.3)",
                            }}
                        >
                            ਲੌਗਇਨ ਕਰੋ | Sign In
                        </Button>
                    </Form.Item>
                </Form>

                <div
                    style={{
                        textAlign: "center",
                        marginTop: 24,
                        paddingTop: 20,
                        borderTop: "1px solid #f0f0f0",
                    }}
                >
                    <Text type="secondary" style={{ fontSize: 12 }}>
                        ਡਿਜੀਟਲ ਡਿਸਪਲੇ ਸਿਸਟਮ
                    </Text>
                    <br />
                    <Text type="secondary" style={{ fontSize: 11 }}>
                        Digital Display System
                    </Text>
                </div>
            </Card>
        </div>
    );
};

export default Login;
